import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button, Chip } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

const formatTime = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleTimeString([], { 
        hour: '2-digit', 
        minute: '2-digit' 
    });
};

const BlogDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const blog = location.state?.blog;

    // Debug: Log the received data


    if (!blog) {
        return (
            <Container maxWidth="md" sx={{ py: 4, mt: 12 }}>
                <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="h5" color="text.secondary" gutterBottom>
                        Blog not found
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        The blog you're looking for doesn't exist or has been removed.
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={() => navigate('/')}
                        sx={{ 
                            backgroundColor: '#cb4422',
                            '&:hover': { backgroundColor: '#a0351a' }
                        }}
                    >
                        Go to Home
                    </Button>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: 4, mt: 12 }}>
      
        

            {/* Blog Header */}
            <Box sx={{ mb: 4 }}>
                
                <Typography variant="h3" fontWeight="bold" sx={{ mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}>
                    {blog.title}
                </Typography>
                
                {/* Date and Time */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <i className="fas fa-calendar-alt" style={{ color: '#cb4422', fontSize: 16 }} />
                        <Typography variant="body2" color="text.secondary">
                            {formatDate(blog.createdAt || blog.created_at)}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <i className="fas fa-clock" style={{ color: '#cb4422', fontSize: 16 }} />
                        <Typography variant="body2" color="text.secondary">
                            {formatTime(blog.createdAt || blog.created_at)}
                        </Typography>
                    </Box>
                </Box>
                {/* Blog Image */}
            {blog.blogImage && (
                <Box 
                    component="img" 
                    src={blog.blogImage} 
                    alt={blog.title} 
                    sx={{ 
                        width: '100%', 
                        height: { xs: 250, md: 400 }, 
                        objectFit: 'cover', 
                        borderRadius: 3, 
                        mb: 4,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                    }} 
                    onError={(e) => {
                        console.error('Image failed to load:', blog.imageUrl);
                        e.target.style.display = 'none';
                    }}
                />
            )}

                {/* about */}
                {blog.about && (
                    <Typography   dangerouslySetInnerHTML={{ __html: blog.about }}
                        variant="h6" 
                        color="text.secondary" 
                        sx={{ 
                            mb: 3,   fontStyle: 'italic',  fontSize: '1.1rem',  lineHeight: 1.6
                        }}
                    >
                        {/* {blog.about} */}
                    </Typography>
                )}
            </Box>
   
        </Container>
    );
};

export default BlogDetail;